// Mirrors the advertising-category parsing in index.html's TrustArc default-consent script.
export const isAdvertisingConsentGranted = (): boolean => {
    const match = document.cookie.match(/(^|;)\s*notice_gdpr_prefs\s*=\s*([^;]+)/);
    const raw = match ? match.pop() : null;
    if (!raw) return true; // no stored choice yet => new visitor => default granted

    const cats = raw.split(':')[0].split(/[|,]/);
    return cats.includes('2'); // '2' = advertising (TrustArc cookie category index)
};
